/**
 * Stan zapisów na opcję albo wariant — jedno wyliczenie dla kart obłożenia
 * i list osób, żeby ten sam próg nie był liczony dwa razy różnie.
 */
export enum OptionOccupancyStatus {
  /** Komplet — limit osiągnięty. */
  FULL = 'FULL',
  /** Zostało mało miejsc; jeszcze można zapisać, ale już warto zerknąć. */
  ALMOST_FULL = 'ALMOST_FULL',
  /** Nikt się nie zapisał. */
  EMPTY = 'EMPTY',
  OPEN = 'OPEN',
}
